import { render, staticRenderFns } from "./EventDetails.vue?vue&type=template&id=17a46c4b&scoped=true&"
import script from "./EventDetails.vue?vue&type=script&lang=js&"
export * from "./EventDetails.vue?vue&type=script&lang=js&"
import style0 from "./EventDetails.vue?vue&type=style&index=0&id=17a46c4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a46c4b",
  null
  
)

component.options.__file = "www/vues/client/projectdisplay/event/EventDetails.vue"
export default component.exports